import { Box, Button, Flex, Image, Text, useToast } from '@chakra-ui/react';
import moment from 'moment';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import timeIcon from 'assets/img/icons/time.svg';
import locationIcon from 'assets/img/icons/location.svg';
import { useJoinEventMutation } from 'rtkQuery/sharespro/queries/events';
import useToastError from 'hooks/shared/useToastError';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';

interface Props {
  eventId: ID;
  startDate: Date;
  endDate: Date;
  location: string;
}

const EventDetailDateTimeInfo: FC<Props> = ({
  eventId,
  startDate,
  endDate,
  location,
}) => {
  const { t } = useTranslation();

  const toast = useToast();
  const toastErrorHandler = useToastError();

  const [join, { isLoading }] = useJoinEventMutation();

  return (
    <>
      <AppCard p="15px">
        <Text fontSize="30px" fontWeight={700} mb="10px">
          {moment(startDate).format('DD MMMM')}
        </Text>
        <Flex mb="10px">
          <Box w="18px" minW="18px" mr="10px">
            <Image src={timeIcon} w="17px" />
          </Box>
          <Text>
            {moment(startDate).format('hh:mm')}-
            {moment(endDate).format('hh:mm')}
          </Text>
        </Flex>
        <Flex mb="10px">
          <Box w="18px" minW="18px" mr="10px" pl="1px">
            <Image src={locationIcon} h="19px" />
          </Box>
          <Text>{location}</Text>
        </Flex>
        <Button
          onClick={() => {
            join(eventId)
              .unwrap()
              .then(() => {
                toast({
                  description: t('youJoinedToEvent'),
                  status: 'success',
                  position: 'top-right',
                  isClosable: true,
                });
              })
              .catch(toastErrorHandler);
          }}
          w="full"
        >
          {t('eventRegister')}
        </Button>
      </AppCard>
      <FullScreenLoader isLoading={isLoading} />
    </>
  );
};

export default EventDetailDateTimeInfo;
